import { ObjectParser } from '../Connection';

export class AllocationProgressLVDetailSeriesVVVFlattened {
  public productId: string;
  public product: number;
  public month: string;
  public price: number;
  public oldDeliveryQty: number;
  public oldFeedInQty: number;
  public newDeliveryQty: number;
  public newFeedInQty: number;
  public correctedDeliveryQty: number;
  public correctedFeedInQty: number;
  private _obj: any;

  public static readObject(map: any): AllocationProgressLVDetailSeriesVVVFlattened {
    const c = new AllocationProgressLVDetailSeriesVVVFlattened();
    // eslint-disable-next-line no-underscore-dangle
    c._obj = map;
    return ObjectParser.fillObject(c, map);
  }

  public toString = (): string => JSON.stringify(this);
}
